import { states } from '../support/helpers/states';
import { IAddress } from '../support/model/IAddress';
import addresser from 'addresser';

export class AddressParser {

    private cityMap = addresser.cities();

    private trimTail = (text: string) => {
        return text.replace(/[^a-zA-Z0-9]*$/g, '');
    };

    // accepts an address as a string, and returns an IAddress object
    parse = (addressString: string): Partial<IAddress> => {
        let street: string = '';
        let city: string = '';
        let state: string = '';
        let zip: string = '';

        let toParse = this.trimTail(addressString);

        // strip off optional country and ignore it
        for (const country of ['US', 'USA', 'UNITED STATES', 'UNITED STATES OF AMERICA']) {
            if (toParse.toUpperCase().endsWith(country)) {
                toParse = toParse.substring(0, toParse.length - country.length - 1);
            }
        }

        toParse = this.trimTail(toParse);

        // accept zip matching a valid pattern
        const zipMatch = toParse.match(/\d{5}(?:[-\s]?\d{4})?$/);
        if (zipMatch?.index) {
            zip = toParse.substring(zipMatch.index, 9999);
            toParse = toParse.substring(0, zipMatch.index - 1);
        }

        toParse = this.trimTail(toParse);

        // accept any recognized state code or name
        for (const st of states) {
            if (toParse.replace('/,/g', ' ').toUpperCase().endsWith(' ' + st.code)) {
                state = st.code;
                toParse = toParse.substring(0, toParse.length - st.code.length - 1);
                break;
            }
            if (toParse.replace('/,/g', ' ').toUpperCase().endsWith(' ' + st.name.toUpperCase())) {
                state = st.code;
                toParse = toParse.substring(0, toParse.length - st.name.length - 1);
                break;
            }
        }

        // otherwise, accept any two upper case letters as a state
        if (!state && toParse.match(/[, ][A-Z]{2}$/)) {
            state = toParse.substring(toParse.length - 2, 9999);
            toParse = toParse.substring(0, toParse.length - 3);
        }

        toParse = this.trimTail(toParse);

        // if there's a comma, the city is everything after the last comma
        const beforeCity = toParse.lastIndexOf(',');
        if (beforeCity > -1) {
            city = toParse.substring(beforeCity + 1, 9999).trim();
            toParse = toParse.substring(0, beforeCity);
        }

        // otherwise, it must match a known city in the selected state
        if (!city && state) {
            const cities = this.cityMap[state];
            for (const c of cities || []) {
                const searchIn = ' ' + toParse.replace(/,/g, ' ').toUpperCase();
                const searchFor = ' ' + c.toUpperCase();
                if (searchIn.endsWith(searchFor)) {
                    city = c;
                    toParse = toParse.substring(0, toParse.length - c.length - 1);
                    break;
                }
                if (searchIn.endsWith(searchFor.replace('SAINT ', 'ST '))) {
                    city = toParse.substring(toParse.length - c.length + 3, 9999);
                    toParse = toParse.substring(0, toParse.length - c.length + 2);
                    break;
                }
            }
        }

        toParse = this.trimTail(toParse);

        // whatever is left is the street
        street = toParse;

        return {
            street,
            city,
            state,
            zip
        };

    };
}
